var BindingAccountsService = (function () {

    function startBindingAccounts() {
        var phone = $('#newBindPhone');

        hideError();
        var isValidate = true;

        if (phone.val().length < 10) {
            isValidate = false;
            showError("Введите корректный номер", ".js-input-error-phone", '#phoneInputWrapper','.js-mod-login-subtitle');
        }

        var strPhone = converStringToPhoneAndAddPrefix(phone.val());

        if (strPhone != undefined) {
            if (strPhone.length < 10 || strPhone.charAt(0) != "9") {
                isValidate = false;
                showError("Введите корректный номер", ".js-input-error-phone", '#phoneInputWrapper','.js-mod-login-subtitle');
            }
        } else {
            isValidate = false;
            showError("Введите корректный номер", ".js-input-error-phone", '#phoneInputWrapper','.js-mod-login-subtitle');
        }

        if (isValidate) {
            AppService.toggleLoader();

            var data = {
                phone: "+7 " + removeBreckets(phone.val()),
            };

            $.ajax({
                url: $(this).prop('action'),
                type: $(this).prop('method'),
                data: JSON.stringify(data),
                contentType: 'application/json',
                success: function (response) {
                    AppService.toggleLoader();
                    $('.modal.in').modal('hide');
                    $('#modalConfirmBindingAccounts').modal('show');
                    $('.js-phone-authorization').text(decoratePhone(response.result.phone)).attr('data-tel', decoratePhone(response.result.phone));

                    $('.js-input-user-phone').val(decoratePhone(response.result.phone));
                },
                error: function (data) {
                    AppService.toggleLoader();
                    showError(data.responseJSON.errors.phone[0], ".js-input-error-phone", '#phoneInputWrapper','.js-mod-login-subtitle');
                }
            });
        }

        return false;
    }

    function decoratePhone(phone){
        var result = converStringToPhoneAndAddPrefix(phone);
        result = "+" + result[0]+ " (" + result[1]+result[2]+result[3]+") " + result[4]+result[5]+result[6] + "-" + result[7]+result[8] + "-" +result[9]+result[10];
        return result;
    }

    function removeBreckets(text){
        var phone = text
            .split('(').join('')
            .split(')').join('');

        return phone;
    }

    function converStringToPhoneAndAddPrefix(text){
        var phone = text ?  text : '';

        phone = phone
            .split('+').join('')
            .split('-').join('')
            .split('_').join('')
            .split(' ').join('')
            .split('(').join('')
            .split(')').join('');

        return phone;
    }

    function hideError(){
        $('.has-error').removeClass('has-error');

        $('.js-mod-login-subtitle').show();
        $('.js-input-error').hide();
        $('.js-mod-code-error').hide();
    }

    function showError(errorMessage, errorSelector, fieldSelector, hideSelector){
        $(fieldSelector).addClass('has-error');
        $(errorSelector).text(errorMessage).show();
        if(hideSelector)
            $(hideSelector).hide();
    }

    function checkCodeValueOnInput() {
        $('.js-next-field-on-input-bind').on('input', function () {
            if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-bind-code-part-1')) {
                $('.js-input-user-bind-code-part-2').focus();
            } else if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-bind-code-part-2')) {
                $('.js-input-user-bind-code-part-3').focus();
            } else if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-bind-code-part-3')) {
                $('.js-input-user-bind-code-part-4').focus();
            } else if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-bind-code-part-4')) {
                $('.js-input-user-bind-code-part-5').focus();
            } else if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-bind-code-part-5')) {
                $('#js-confirm-binding-accounts').trigger("submit");
            } else {
                $(this).val('');
            }
        });
    }

    function confirmBindingAccounts() {
        var phone = $('#bindPhone').attr("data-tel");
        var code = $('.js-input-user-bind-code-part-1').val()
            + $('.js-input-user-bind-code-part-2').val()
            + $('.js-input-user-bind-code-part-3').val()
            + $('.js-input-user-bind-code-part-4').val()
            + $('.js-input-user-bind-code-part-5').val();

        AppService.toggleLoader();
        console.log(phone);

        var data = {
            phone: removeBreckets(phone),
            code: code
        };


        $.ajax({
            url: $(this).prop('action'),
            type: $(this).prop('method'),
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function () {
                AppService.toggleLoader();
                AppService.refresh();
            },
            error: function (data) {
                AppService.toggleLoader();
                if(data.responseJSON.errors.bindPhone)
                    showError(data.responseJSON.errors.bindPhone[0], ".js-mod-code-error-bind-confirm", '.js-mod-code','.js-mod-login-subtitle');
                else if(data.responseJSON.errors.bindPhoneNotExist)
                    showError(data.responseJSON.errors.
                        bindPhoneNotExist[0], ".js-mod-code-error-bind-confirm", '.js-mod-code','.js-mod-login-subtitle');
                else
                    showError(data.responseJSON.message, ".js-mod-code-error-bind-confirm", '.js-mod-code','.js-mod-login-subtitle');
            }
        });

        return false;
    }

    function checkCodeValueOnKeyUp() {
        $('.js-next-field-on-keyup-bind').keyup(function () {
            if (event.keyCode === 8 && $(this)[0].classList.contains('js-input-user-bind-code-part-5')) {
                $('.js-input-user-bind-code-part-4').focus();
            } else if (event.keyCode === 8 && $(this)[0].classList.contains('js-input-user-bind-code-part-4')) {
                var el = $('.js-input-user-bind-code-part-3');
                el.val("");
                el.focus();
            } else if (event.keyCode === 8 && $(this)[0].classList.contains('js-input-user-bind-code-part-3')) {
                var el = $('.js-input-user-bind-code-part-2');
                el.val("");
                el.focus();
            } else if (event.keyCode === 8 && $(this)[0].classList.contains('js-input-user-bind-code-part-2')) {
                var el = $('.js-input-user-bind-code-part-1');
                el.val("");
                el.focus();
            }
        });
    }

    function init() {
        $('#js-start-binding-accounts').submit(startBindingAccounts);
        $('#js-confirm-binding-accounts').submit(confirmBindingAccounts);

        checkCodeValueOnInput();
        checkCodeValueOnKeyUp();
    }

    return {
        init: init
    }
})();

$(BindingAccountsService.init);